// 広告関連のハンドラー
import { AD_CONFIG } from '../config/ads-config';

/**
 * 広告読み込み機能
 */
export function loadAds(): void {
    if (!AD_CONFIG.enabled) {
        // 広告が無効な場合、広告エリアを非表示
        ['ad-header', 'ad-sidebar', 'ad-footer'].forEach(id => {
            const el = document.getElementById(id);
            if (el) el.style.display = 'none';
        });
        return;
    }
    
    // ビューポート幅チェック
    if (window.innerWidth < AD_CONFIG.showConditions.minViewportWidth) {
        return;
    }
    
    // 遅延表示
    setTimeout(() => {
        loadAdSenseAds();
    }, AD_CONFIG.showConditions.delayBeforeShow);
}

function loadAdSenseAds(): void {
    // Google AdSense スクリプトを読み込み
    if (!document.querySelector('script[src*="googlesyndication"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CONFIG.adSenseClientId}`;
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);
    }
    
    // 各広告ユニットを初期化
    (['header', 'sidebar', 'footer'] as const).forEach(position => {
        const container = document.getElementById(`ad-${position}`);
        if (container && !container.querySelector('.adsbygoogle')) {
            const ins = document.createElement('ins');
            ins.className = 'adsbygoogle';
            ins.style.display = 'block';
            ins.setAttribute('data-ad-client', AD_CONFIG.adSenseClientId);
            ins.setAttribute('data-ad-slot', AD_CONFIG.adSlots[position]);
            ins.setAttribute('data-ad-format', 'auto');
            ins.setAttribute('data-full-width-responsive', 'true');
            container.appendChild(ins);
            
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                console.error('AdSense error:', e);
            }
        }
    });
}

